import { Point } from "@react-three/drei";
import { Vector3 } from "@react-three/fiber";

interface HoverablePointProps {
  index: number;
  onHover: (index: number) => void;
  onUnhover: (index: number) => void;
  position: Vector3;
}

export function HoverablePoint(props: HoverablePointProps) {
  return (
    <Point
      {...props}
      onPointerOver={(e) => {
        e.stopPropagation();
        props.onHover(props.index);
      }}
      onPointerOut={(e) => {
        e.stopPropagation();
        props.onUnhover(-1);
      }}
      onClick={(e) => {
        e.stopPropagation();
        props.onHover(props.index);
      }}
    />
  );
}
